<template>
  <ModalView
    v-model="show"
    title="Change Password"
    @ok="confirm"
    ok-title="Change Password"
    :busy="saving"
    :disable-ok="!canSubmit"
  >
    <form @submit.prevent="confirm" class="d-flex flex-column gap-3">
<!--      <label class="form-label">Current Password</label>-->
<!--      <input type="password" v-model="currentPassword" class="form-control" />-->
      <div>
        <label class="form-label">New Password</label>
        <input ref="newPassword" type="password" v-model="newPassword" class="form-control" autocomplete="new-password" />
      </div>
      <div>
        <label class="form-label">Confirm New Password</label>
        <input type="password" v-model="confirmNewPassword" class="form-control" />
      </div>

      <div v-if="showPasswordError" class="alert alert-danger">
        {{ passwordError }}
      </div>
    </form>
  </ModalView>
</template>

<script>
import ModalView from "@/components/common/ModalView.vue";
import {Session} from "@/models/User";

export default {
  components: {ModalView},
  props: {
    modelValue: Boolean
  },
  emits: ['update:modelValue'],
  data() {
    return {
      saving: false,
      // currentPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    };
  },
  computed: {
    passwordError() {
      if (!this.newPassword) {
        return 'New password is required';
      } else if (this.newPassword.length < 12) {
        return 'Password must be at least 12 characters';
      } else if (this.newPassword !== this.confirmNewPassword) {
        return 'Passwords must match';
      } else {
        return null;
      }
    },
    canSubmit() {
      return !this.passwordError;
    },
    showPasswordError() {
      return this.newPassword.length > 0 && Boolean(this.passwordError);
    },
    show: {
      get() {
        return this.modelValue;
      },
      set(v) {
        if (!v) {
          this.newPassword = this.confirmNewPassword = '';
        } else {
          this.$nextTick(() => this.$refs.newPassword.focus());
        }
        this.$emit('update:modelValue', v);
      }
    }
  },
  methods: {
    async confirm() {
      this.saving = true;
      try {
        await Session.currentUser.value.updatePassword(this.newPassword);
        this.show = false;
      } finally {
        this.saving = false;
      }
    }
  }
}
</script>
